import React from 'react';
import { Link } from 'react-router-dom';
import { Icon, Popup } from 'semantic-ui-react';
import EMAIL_ICON from 'shared/constants/EMAIL_ICON';

const Email = ({ email, email_type, isReadOnly, duplicateEmailContactId = null }) => (
    <React.Fragment>
        <Popup
            trigger={<Icon name={EMAIL_ICON[email_type] || 'envelope'} color='grey' />}
            content={email_type}
            position='top center'
            inverted
        />
        <p className={isReadOnly || duplicateEmailContactId ? 'ContactInfo__contact--readOnly' : 'ContactInfo__contact'}>{email}</p>
        {duplicateEmailContactId && <p className="ContactInfo__contact">
            <Popup
                trigger={<Icon className='fa-solid fa-triangle-exclamation WarningRed' />}
                content={(
                    <div className="MinimumErrors">
                        Email matches an <Link className='RecordPhonesForm__matchLink' target={"_blank"} to={`/contact/${duplicateEmailContactId}`}>existing record</Link>
                    </div>
                )}
                position="bottom right"
                offset={[15, 0]}
                on={"click"}
            />
        </p>}
    </React.Fragment>
);

export default Email;
